import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { TOKEN } from 'src/app/components/_shared/constants/local-storage-constants';

@Injectable({
  providedIn: 'root',
})
export class AuthenticatedGuardService {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate() {
    if (this.authService.loggedIn()) {
      if (this.authService.isAwaiting2FA()) {
        return this.router.parseUrl('/totp');
      }

      return true;
    } else {
      localStorage.removeItem(TOKEN);
      return this.router.parseUrl('/login');
    }
  }
}

export const isAuthenticatedGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(AuthenticatedGuardService).canActivate();
};
